import React, { useState } from 'react';
import CookieConsent, { getCookieConsentValue, resetCookieConsentValue } from 'react-cookie-consent';
import '../../styles/cookiesBanner.css';
import { FaCog, FaTimes } from 'react-icons/fa';

const CogIcon = FaCog as React.ComponentType<{ size?: number }>;
const CloseIcon = FaTimes as React.ComponentType<{ size?: number }>;

const CookieBanner = () => {
    const [showSettings, setShowSettings] = useState(false);
    const [statsCookies, setStatsCookies] = useState(true);
    const [marketingCookies, setMarketingCookies] = useState(true);

    const handleSaveSettings = () => {
        setShowSettings(false);
        console.log("Estatísticas:", statsCookies, "Marketing:", marketingCookies);
    };

    const handleCloseModal = () => {
        setShowSettings(false);
    };

    return (
        <>
            <CookieConsent
                location="bottom"
                buttonText="Aceitar tudo"
                declineButtonText="Rejeitar tudo"
                enableDeclineButton
                flipButtons
                cookieName="cookieConsent"
                containerClasses="CookieConsent"
                contentClasses="cookie-content"
                style={{ boxShadow: "0 -4px 20px rgba(0, 0, 0, 0.1)" }}
                buttonStyle={{
                    backgroundColor: "#6b2a57",
                    color: "#fff",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    fontWeight: "500"
                }}
                declineButtonStyle={{
                    backgroundColor: "#fff",
                    color: "#6b2a57",
                    border: "1px solid #6b2a57",
                    padding: "8px 16px",
                    borderRadius: "6px",
                    fontWeight: "500"
                }}
                expires={365}
            >
                <div className="cookie-header">
                    <div className="cookie-header-top">
                        <h3 className="cookie-title">Controle sua privacidade</h3>
                        <button className="cookie-config-btn" onClick={() => setShowSettings(true)}>
                            <CogIcon size={18} />
                        </button>
                    </div>
                    <p className="cookie-description">
                        Usamos cookies essenciais e opcionais para melhorar a navegação.
                    </p>
                </div>
            </CookieConsent>

            {showSettings && (
                <div className="cookie-modal-overlay">
                    <div className="cookie-modal">
                        <div className="cookie-modal-header">
                            <h2>Configurações de cookies</h2>
                            <button className="cookie-modal-close" onClick={handleCloseModal}>
                                <CloseIcon size={20} />
                            </button>
                        </div>
                        <p className="cookie-desc">Você pode escolher quais cookies quer aceitar</p>

                        {/* Cookies obrigatórios */}
                        <div className="cookie-section required">
                            <div className="cookie-section-content">
                                <strong>Cookies obrigatórios</strong>
                                <p>Eles são cookies para garantir o funcionamento adequado do site.</p>
                            </div>
                            <span className="always-on">Sempre ativo</span>
                        </div>

                        {/* Cookies de estatísticas */}
                        <div className="cookie-section">
                            <div className="cookie-section-content">
                                <strong>Cookies de estatísticas</strong>
                                <p>São usados para coletar informações para exibir conteúdos específicos.</p>
                            </div>
                            <div className="cookie-section-toggle">
                                <input 
                                    type="checkbox" 
                                    checked={statsCookies} 
                                    onChange={() => setStatsCookies(!statsCookies)} 
                                />
                            </div>
                        </div>

                        {/* Cookies de marketing */}
                        <div className="cookie-section">
                            <div className="cookie-section-content">
                                <strong>Cookies de marketing</strong>
                                <p>São usados para exibir publicidade ou conteúdos específicos para um navegador.</p>
                            </div>
                            <div className="cookie-section-toggle">
                                <input 
                                    type="checkbox" 
                                    checked={marketingCookies} 
                                    onChange={() => setMarketingCookies(!marketingCookies)} 
                                />
                            </div>
                        </div>

                        <button className="cookie-save-btn" onClick={handleSaveSettings}>
                            Confirmar configurações
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default CookieBanner;